export const listConstants = {
	SHOWDETAIL: 'SHOWDETAIL',
	GOTOEDIT: 'GOTOEDIT',
	GO_TO_DOWNLOAD: 'GO_TO_DOWNLOAD'
};

export default listConstants;